import type { CanDeactivateFn } from '@angular/router';

import type { AssessmentComponent } from '../taker/assessment/assessment.component';

export const onExitSurvey: CanDeactivateFn<AssessmentComponent> = c => c.onExitSurvey();
